import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Cpu, FileWarning } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-dark-DEFAULT relative overflow-hidden" data-id="element-147">
      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-150">
            Why Your Disputes Are <span className="text-danger" data-id="element-151">FAILING</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-152">
            It's not your fault. The system is rigged against you by a computer
            program called e-OSCAR.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-153">
          {[{
          icon: Cpu,
          title: 'The AI Trap',
          desc: "Credit bureaus don't read your letters. They scan them with OCR technology and assign a 2-digit code to reject you automatically."
        }, {
          icon: XCircle,
          title: "The 'Verified' Lie",
          desc: "When they say 'verified', they didn't check the contract. They just checked that your name and address matched their database."
        }, {
          icon: FileWarning,
          title: 'The Stall Tactics',
          desc: "They send confusing letters asking for more ID, claiming 'frivolous dispute', or just ignoring you hoping you'll give up."
        }].map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-dark-100 p-8 rounded-lg border border-dark-200 hover:border-danger/50 transition-colors group" data-id="element-154">
              <div className="w-16 h-16 bg-dark-200 rounded-full flex items-center justify-center mb-6 group-hover:bg-danger/20 transition-colors" data-id="element-155">
                <item.icon className="w-8 h-8 text-danger" data-id="element-156" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-white mb-4" data-id="element-157">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-158">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}